<template>
  <div class="adapt">
    <div>
      <el-tabs v-model="activeName"
    @tab-click="onTabClick" class="i-tab" :class="offsetClass">
      <el-tab-pane
        :label="item.label"
        :name="item.name"
        v-for="item in tabList"
        :key="item.name">
          <component
            ref="PreviewRecord"
            :is="item.component"
            :gradeId="gradeId"
            :classId="classId"
            :masterClassId='masterClassId'/>
        </el-tab-pane>
    </el-tabs>
    </div>
  </div>
</template>

<script>
import ClassProfile from './class-profile.vue';
import KnowledgeLearn from './knowledge-learn.vue';
import CommonError from './common-error.vue';

export default {
  name: 'AdaptAnalysis',
  props: {
    gradeId: {},
    classId: {},
    masterClassId: {},
  },
  components: {
    ClassProfile,
    KnowledgeLearn,
    CommonError,
  },
  data() {
    return {
      activeName: 'ClassProfile',
      offsetClass: 'l-0',
      tabList: [
        {
          label: '班级概况',
          name: 'ClassProfile',
          component: ClassProfile,
        },
        // {
        //   label: '知识点学情',
        //   name: 'KnowledgeLearn',
        //   component: KnowledgeLearn,
        // },
        {
          label: '共性错题',
          name: 'CommonError',
          component: CommonError,
        },
      ],
    };
  },
  methods: {
    onTabClick(e) {
      this.offsetClass = `l-${e.index}`;
    },
  },
};
</script>

<style lang="scss" scoped>
 .adapt {
   .i-tab {
  /deep/ {
    .el-tabs__header {
      line-height: 70px;
      margin: 0;
      background-color: #F4FAFF;
    }
    .el-tabs__item {
      height: 34px;
      line-height: 34px;
      &.is-active {
        color: #fff;
        background-color: rgba(25, 137, 250, 1);
        border-radius:34px;
      }
    }
    .el-tabs__nav-wrap {
      // overflow: visible;
      display: flex;
      &::after {
        width: 0px;
      }
    }
    .el-tabs__nav-scroll {
      overflow: visible;
    }
    .el-tabs__active-bar {
      background-color: rgba(25, 137, 250, 1);
      height: 0px;
      border-radius: 2px;
      width: 100px !important;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 0px;
        height: 0px;
        border: 0px solid #fff;
        box-sizing: border-box;
        background: #fff;
        border-radius: 50%;
        top: -4px;
      }
    }
  }
}
.l-0 /deep/{
  .el-tabs__active-bar {
    left: 18px;
  }
}
.l-1 /deep/ {
  .el-tabs__active-bar {
    left: 60px;
  }
}
.l-2 /deep/ {
  .el-tabs__active-bar {
    left: 96px;
  }
}
.l-3 /deep/ {
  .el-tabs__active-bar {
    left: 138px;
  }
}
.l-4 /deep/ {
  .el-tabs__active-bar {
    left: 180px;
  }
}
 }
</style>
